<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="float-right mb-3" v-if="!loading" id="viewOrderActions">
                    <div class="dropdown">
                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <button class="dropdown-item" id="btnViewOrderCancel" @click="onDocumentsActionClick"
                                    v-show="order.orderStatusId === orderStatus.readyForUpliftment || 
                                            order.orderStatusId === orderStatus.complete ||
                                            order.orderStatusId === orderStatus.uplifted">
                                Documents
                            </button>
                            <button class="dropdown-item" id="btnViewOrderCancel" @click="uploadBol"
                                    v-show="order.orderStatusId === orderStatus.readyForUpliftment">
                                Upload BOL
                            </button>
                            <button class="dropdown-item" id="btnViewOrderCancel" @click="onCancelOrderClick"
                                    v-show="order.orderStatusId !== orderStatus.cancelled && order.orderStatusId !== orderStatus.complete && order.orderStatusId !== orderStatus.uplifted">
                                Cancel
                            </button>
                            <button class="dropdown-item" id="btnViewOrderViewTrackingHistory" @click="viewTrackingHistory">
                                View Tracking History
                            </button>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <div v-if="!loading">
                    
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <p>
                                        <b>Customer:</b> {{order.registeredCompanyName}}
                                    </p>
                                    <p>
                                        <b>Order Date:</b> {{order.insertedOn}}
                                    </p>
                                    <p>
                                        <b>Order Type:</b> {{order.orderType}}
                                    </p>
                                    <p>
                                        <b>Order Status:</b> {{order.orderStatus}}
                                    </p>
                                    <p>
                                        <b>Customer Purchase Order Number:</b> {{order.customerPurchaseOrder}}
                                    </p>
                                    <p>
                                        <b>Transporter:</b> {{order.transporter}}
                                    </p>
                                    <p>
                                        <b>Vehicle Make:</b> {{order.vehicleMake}}
                                    </p>
                                    <p>
                                        <b>Vehicle Model:</b> {{order.vehicleModel}}
                                    </p>
                                    <p>
                                        <b>Vehicle Registration:</b> {{order.vehicleRegistration}}
                                    </p>
                                    <p v-if="order.expectedUpliftmentDate !== null && order.expectedUpliftmentDate !== undefined">
                                        <b>Expected Upliftment:</b> {{order.expectedUpliftmentDate}}
                                    </p>
                                    <p v-if="order.orderStatusId === orderStatus.complete">
                                        <b>Order Completed On:</b> {{order.statusLastUpdatedOn}}
                                    </p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTypeId="orderTypeId"
                                    :orderTotal="orderGrandTotal"></order-items-table>

                        </div>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>

    <!-- TODO: remove -->
    <div class="modal fade" id="stillInDevModal" tabindex="-1" aria-labelledby="stillInDevModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="stillInDevModalLabel">Still in development</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Still in development
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light" data-dismiss="modal">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
    <order-documents-modal
            :orderId="documentsModal.orderId"
            :heading="documentsModal.heading"
            :modalId="documentsModal.modalId"
            :showModal="documentsModal.showModal"
            @closeModal="onDocumentsModalClose"></order-documents-modal>
    <upload-bol-modal
            :orderId="uploadBolModal.orderId"
            :showModal="uploadBolModal.showModal"
            :modalId="uploadBolModal.modalId"
            @closeModal="onUploadBolModalClose"></upload-bol-modal>
    <div class="modal fade" :id="cancelOrderModalId" tabindex="-1" aria-labelledby="cancelOrderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="cancelOrderModalLabel">Cancel Order #{{order.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Cancel Order? Are you sure?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        No
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onCancelYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
